export function getAttr(el, attr) {
  return el.getAttribute(attr);
}


// WEBPACK FOOTER //
// ./~/tiny-slider/src/helpers/getAttr.js